import { Component, Input, OnChanges } from '@angular/core';
import { ReportInfo, ReportRecord, ReportView, TemplateProjectionMap } from '../../../../models/report.model';
import { TemplateField } from '../../../../models/template.model';
import { GroupBase } from '../../../../models/blueprint.model';
import { EditableFieldsService } from '../../../editable-fields.service';

@Component({
  selector: 'rep-presentation-dynamic-view-header',
  templateUrl: './record-header.component.html',
  styleUrls: ['./record-header.component.scss'],
  standalone: false,
})
export class PresentationDynamicViewHeaderComponent implements OnChanges {
  @Input() reportRecordData: ReportRecord;
  @Input() reportData: ReportInfo;
  @Input() currentView: ReportView;
  @Input() headerGroups: GroupBase<TemplateField>[];
  @Input() templateProjectionMap: TemplateProjectionMap;
  titleGroup: GroupBase<TemplateField>;
  attributesGroup: GroupBase<TemplateField>;
  constructor(public editableFieldsService: EditableFieldsService) {}

  ngOnChanges() {
    if (!!this.headerGroups) {
      const [titleGroup, attributesGroup] = this.headerGroups;
      this.titleGroup = titleGroup;
      this.attributesGroup = attributesGroup;
    }
  }
}
